export default "__VITE_ASSET__ICcQkR9r__";